<template>
    <div class="tvb-cookies" :class="{ show: showCookies }">
        <div class="tvb-cookies-container">
            <div class="tvb-cookies_content">
                <h3 class="tvb-cookies_content-title">
                    <tvb-svg-icon name="icon_cookie" class="tvb-cookies_content-cookies" />
                    This service uses cookies.
                </h3>
                <p class="tvb-cookies_content-description">
                    By visiting the site, you agree to the use of cookies
                    <a
                        href="https://img.tvb.com/p/programmeconnect2020/cookies.pdf"
                        target="_blank"
                    >
                        more information
                    </a>
                </p>
            </div>
            <button class="tvb-cookies_agree" @click="showCookies = false">
                <span>OK</span>
                <div class="tvb-cookies_agree-mask"></div>
            </button>
        </div>
    </div>
</template>

<script setup name="TvbCookies">
import { onMounted, ref, watch } from 'vue'
import { setCookie, getCookie } from '@/utils/cookies'

const showCookies = ref(false)

onMounted(() => {
    setTimeout(() => {
        showCookies.value = !getCookie('_cookie_policy')
        // document.querySelector('body').style.overflow = showCookies.value ? 'hidden' : ''
    }, 1000)
})

watch(showCookies, showCookies => {
    if (!showCookies) {
        setCookie('_cookie_policy', 'true', 99999)
    }
    // document.querySelector('body').style.overflow = showCookies ? 'hidden' : ''
})
</script>

<style lang="scss" scoped>
.tvb-cookies {
    background-color: rgba(5, 5, 6, 0.9);
    position: fixed;
    left: 16px;
    right: 16px;
    z-index: 99999;
    width: calc(100vw - 96px);
    bottom: -300px;
    transition: bottom 500ms;
    padding: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    &.show {
        bottom: 16px;
    }

    .tvb-cookies-container {
        margin: auto;
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
    }

    .tvb-cookies_content {
        width: calc(100vw - 16px * 2 - 32px * 2 - 32px - 120px);
        .tvb-cookies_content-title {
            color: #ffffff;
            font-size: 22px;
            font-weight: 500;
            letter-spacing: 0.1px;
            line-height: 32px;
            display: flex;
            align-items: center;
            .tvb-cookies_content-cookies {
                font-size: 24px;
                margin-right: 8px;
            }
        }
        .tvb-cookies_content-description {
            color: rgba(255, 255, 255, 0.85);
            font-size: 18px;
            line-height: 22px;
            margin-top: 8px;
            padding-right: 1px;
            a {
                color: #0095d8;
            }
        }
    }
    .tvb-cookies_agree {
        height: 44px;
        width: 120px;
        border-radius: 6px;
        background-color: #0095d8;
        color: #fff;
        border: none;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        cursor: pointer;
        position: relative;

        & span {
            width: 100%;
            position: absolute;
            top: 10px;
            left: 0px;
            z-index: 10;
        }

        .tvb-cookies_agree-mask {
            display: none;
            width: 120px;
            height: 44px;
            background: rgba(0, 0, 0, 0.2);
            border-radius: 6px;
            position: absolute;
            top: 0px;
            left: 0px;
            z-index: 1;
        }

        &:active {
            opacity: 0.5;
        }

        &:hover {
            .tvb-cookies_agree-mask {
                display: block;
            }
        }

        @media (max-width: 740px) {
            margin-left: 24px;
        }
        @media (max-width: 800px) {
            margin-top: 8px;
        }
    }

    @media screen and (max-width: 767px) {
        left: 12px;
        width: calc(100vw - 56px);
        min-width: 264px;
        padding: 16px;
        border-radius: 6px;

        &.show {
            bottom: 12px;
        }

        .tvb-cookies-container {
            display: inline-block;
            text-align: center;

            & > * {
                display: block;
            }
        }

        .tvb-cookies_content {
            width: 100%;
            .tvb-cookies_content-title {
                font-size: 16px;
                line-height: 22px;
                letter-spacing: 0.5px;
                display: inline-flex;
                text-align: center;

                .tvb-cookies_content-cookies {
                    font-size: 20px;
                    margin-right: 5px;
                }
            }

            .tvb-cookies_content-description {
                font-size: 14px;
                line-height: 20px;
                margin-top: 9px;
                padding-right: 0px;
            }
        }

        .tvb-cookies_agree {
            width: 108px;
            height: 32px;
            background-color: #0075c2;
            font-size: 14px;
            line-height: 20px;
            color: #eeeeee;
            letter-spacing: 0.3px;
            margin-left: auto;
            margin-right: auto;
            margin-top: 16px;

            & span {
                top: 6px;
                color: #eeeeee;
            }

            .tvb-cookies_agree-mask {
                display: none;
                width: 108px;
                height: 32px;
                background: rgba(0, 0, 0, 0.2);
                border-radius: 6px;
                position: absolute;
                top: 0px;
                left: 0px;
                z-index: 1;
            }

            &:active {
                opacity: 0.5;
            }

            &:hover {
                .tvb-cookies_agree-mask {
                    display: none;
                }
            }
        }
    }
}

.cookie-empty-space {
    width: 100%;
    max-width: 80px;
}
</style>
